<template>
    <vertical-table v-if="form" :items="computedItems" v-bind="{ itemsPerRow }">
        <template v-for="{ term, type, key, keys, lastKey, props, computedData } in computedItems">
            <template v-if="$slots[term]">
                <slot :slot="term" :name="term" />
            </template>
            <template v-else-if="mode == 'view'">
                <template v-if="type == 'file-chips'">
                    <v-file-chips :value="computedData" v-bind="props" :key="key" :slot="term" mode="view" />
                </template>
                <template v-if="type == 'images-tile'">
                    <v-images-tile-field v-model="findData(keys)[lastKey]" v-bind="props" :key="key" :slot="term" mode="view" />
                </template>
            </template>
            <template v-else-if="mode == 'form'">
                <div :slot="term" :key="key" class="h-100">
                    <template v-if="type == 'address'">
                        <v-address-field v-model="findData(keys)[lastKey]" v-bind="props" :btnAttrs="{ color: 'grey-6 white--text', className: 'w-80px w-lg-100px' }" @input="emit" />
                    </template>
                    <template v-if="type == 'combobox'">
                        <v-combobox v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'currency'">
                        <v-currency-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'date'">
                        <v-date-field v-model="findData(keys)[lastKey]" type="date" max="2999-12-31" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'dates'">
                        <v-row align="center" no-gutters>
                            <v-col> <v-date-field v-model="findData(keys)[lastKey]['startsAt']" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                            <v-col class="px-10" cols="auto"> ~ </v-col>
                            <v-col> <v-date-field v-model="findData(keys)[lastKey]['endsAt']" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                        </v-row>
                    </template>
                    <template v-if="type == 'datetime'">
                        <datetime-picker-field v-model="findData(keys)[lastKey]" label="시작" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'datetimes'">
                        <v-row align="center" no-gutters>
                            <v-col> <datetime-picker-field v-model="findData(keys)[lastKey]['startsAt']" type="date" label="시작" v-bind="props" @input="emit" /> </v-col>
                            <v-col class="px-10" cols="auto"> ~ </v-col>
                            <v-col> <datetime-picker-field v-model="findData(keys)[lastKey]['endsAt']" type="date" label="종료" v-bind="props" @input="emit" /> </v-col>
                        </v-row>
                    </template>
                    <template v-if="type == 'duration'">
                        <v-row align="center" no-gutters>
                            <v-col> <v-date-field v-model="findData(keys)[lastKey][0]" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                            <v-col class="px-10" cols="auto"> ~ </v-col>
                            <v-col> <v-date-field v-model="findData(keys)[lastKey][1]" type="date" max="2999-12-31" v-bind="props" @input="emit" /> </v-col>
                        </v-row>
                    </template>
                    <template v-if="type == 'editor'">
                        <naver-smarteditor v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'email'">
                        <v-email-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'file'">
                        <v-file-input v-model="findData(keys)[lastKey]" v-bind="props" @change="emit" />
                    </template>
                    <template v-if="type == 'file-chips'">
                        <v-file-chips v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'hours'">
                        <v-row align="center" no-gutters>
                            <v-col> <v-time-field v-model="findData(keys)[lastKey]['startsAt']" v-bind="props" @input="emit" /> </v-col>
                            <v-col class="px-10" cols="auto"> ~ </v-col>
                            <v-col> <v-time-field v-model="findData(keys)[lastKey]['endsAt']" v-bind="props" @input="emit" /> </v-col>
                        </v-row>
                    </template>
                    <template v-if="type == 'images-tile'">
                        <v-images-tile-field v-model="findData(keys)[lastKey]" v-bind="props" @change="emit" />
                    </template>
                    <template v-if="type == 'password'">
                        <v-password-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'phone'">
                        <v-phone-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'select'">
                        <v-select v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'switch'">
                        <v-switch v-model="findData(keys)[lastKey]" v-bind="props" inset dense hide-details class="pl-4" @change="emit" />
                    </template>
                    <template v-if="type == 'text'">
                        <v-text-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'textarea'">
                        <v-textarea v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>
                    <template v-if="type == 'username'">
                        <v-username-field v-model="findData(keys)[lastKey]" v-bind="props" @input="emit" />
                    </template>

                    <template v-if="props.coda">
                        <p class="page-text--sm grey-6--text pl-8 pt-8 font-weight-regular" style="white-space: pre-line">
                            {{ props.coda }}
                        </p>
                    </template>
                </div>
            </template>
        </template>
    </vertical-table>
</template>

<script>
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES } from "@/assets/variables";

import DatetimePickerField from "./datetime-picker-field.vue";
import NaverSmarteditor from "../plugins/naver/naver-smarteditor.vue";
import VAddressField from "./v-address-field.vue";
import VDateField from "../plugins/vuetify/v-date-field.vue";
import VEmailField from "./v-email-field.vue";
import VFileChips from "../plugins/vuetify/v-file-chips.vue";
import VImagesTileField from "../plugins/vuetify/v-images-tile-field.vue";
import VPasswordField from "../plugins/vuetify/v-password-field.vue";
import VPhoneField from "./v-phone-field.vue";
import VTimeField from "../plugins/vuetify/v-time-field.vue";
import VUsernameField from "../plugins/vuetify/v-username-field.vue";
import VerticalTable from "./vertical-table.vue";

export default {
    components: {
        DatetimePickerField,
        NaverSmarteditor,
        VAddressField,
        VDateField,
        VEmailField,
        VFileChips,
        VImagesTileField,
        VPasswordField,
        VPhoneField,
        VTimeField,
        VUsernameField,
        VerticalTable,
    },
    props: {
        mode: { type: String, default: "form" },

        value: { type: Object, default: () => ({}) },
        items: { type: Array, default: () => [] },
        itemsPerRow: { type: [Number, String], default: 1 },
    },
    data: () => ({
        form: undefined,
    }),
    computed: {
        computedItems() {
            return this.$props.items.map((item) => {
                let { cols, data, key, message, required, term, type, props__input, formatter, ...props } = item;
                if (props__input) props = { ...props, ...props__input };

                let keys = key?.split?.(".") || [];
                let lastKey = keys.pop();
                data = data ?? this.findData(keys)?.[lastKey];

                if (type == "currency") {
                    data = data?.format?.() || data || props?.data_default;
                    if (data) data += props?.suffix || "";
                }
                if (type == "datetime") {
                    data = data?.toDateTime?.() || data || props?.data_default;
                }

                if (type == "duration") {
                    if (data?.[0] || data?.[1]) {
                        data = `${data[0] ? this.$dayjs(data[0]).format("YYYY.MM.DD. (ddd)") : ""} ~ ${data[1] ? this.$dayjs(data[1]).format("YYYY.MM.DD. (ddd)") : ""}`;
                    } else data = undefined;
                }

                if (type == "education") {
                    try {
                        let { institutionType, attendingStatus } = data || {};
                        data = [EDUCATION_INSTITUTION_TYPES[institutionType]?.text || "", EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""].join(" ").trim() || data || props?.data_default;
                    } catch {
                        data = data;
                    }
                }

                if (type == "phone") {
                    data = data?.phoneNumberFormat?.() || data || props?.data_default;
                }

                if (type == "residence") {
                    try {
                        let { address1, address2 } = data || {};
                        data = [address1 || "", address2 || ""].join(" ").trim() || data || props?.data_default;
                    } catch {
                        data = data || props?.data_default;
                    }
                }

                if (formatter) {
                    data = formatter(data) || data;
                }

                let computedItem = {
                    cols,
                    data,
                    computedData: data,
                    key,
                    keys,
                    message,
                    required,
                    lastKey,
                    props,
                    term,
                    type,
                };

                if (this.mode == "form") delete computedItem.data;
                else delete computedItem.required;

                if (this.mode == "view") {
                    switch (type) {
                        case "images-tile":
                        case "file-chips": {
                            delete computedItem.data;
                            break;
                        }
                    }
                }

                return computedItem;
            });
        },
        slots() {
            return this.$slots;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
        findData(keys) {
            return keys.reduce((o, key) => o?.[key], this.form) || this.form;
        },
    },
};
</script>

<style></style>
